import { NumberDeltaComponent } from '../charts/number-delta-component'

export class AFMentionsPerDayAverage extends NumberDeltaComponent {
 static config = {
  selector: 'afMentionsPerDayAverage',
  controller: AFMentionsPerDayAverage,
  bindings: NumberDeltaComponent.config.bindings,
  template: NumberDeltaComponent.config.template,
 }
}
